import { Component, Watch } from "vue-property-decorator";
import { Getter, Mutation, Action } from "vuex-class";
import BasePage from "@/views/BasePage/BasePage";
import CodeInput from "@/components/codeInput/codeInput";
import { configService } from "@/settings/api-url";
import Loading from "@/components/loading/loading";
import { segment_track } from "@/settings/segment";

@Component({
  components: {
    CodeInput,
    Loading,
  },
})
export default class LoginRegister extends BasePage {
  @Action action_getUser;
  @Action action_putUser;
  @Action action_createUser;
  @Action action_postLogin;
  @Action action_getCountries;
  @Action action_getCities;
  @Action action_getCountry;
  @Action action_getCity;

  @Mutation PATH_TEMPORAL: any;
  @Mutation IS_SELECT_COUNTRY: any;
  @Mutation LOGIN_HELPER: any;

  @Getter getIsToken: any;
  @Getter getCountry: any;
  @Getter getUser: any;
  @Getter getCountries: any;
  @Getter getPathTemporal: any;
  @Getter getCity: any;
  @Getter getCities: any;
  @Getter getLoginHelper: any;

  form = {
    first_name: "",
    last_name: "",
    password: "",
    email: "",
  };
  showLoginButton = false;
  wrong = [];
  showPassword = false;
  isConfirmation = false;
  isLoading = false;
  country = {
    id: 2,
    name: "colombia",
    country_code: "co",
    language: "es-CO",
    currency: "COP",
  };

  city = {
    id: 3,
    country_code: "co",
    name: "Bogotá",
  };

  isWrong(value) {
    const index = this.wrong.findIndex((err) => err === value);
    return index !== -1;
  }

  async mounted() {
    this.wrong = [];
    this.validateHelper();
    try {
      await this.action_getCountries();
      await this.action_getCities();
    } catch (error) {
      this.$swal({
        title: "Error",
        text:
          "¡Ups! Hubo un error de nuestra parte." +
          "Por favor, intenta de nuevo y si el error persiste comunícate con nosotros a través del chat." +
          `Error: ${error}`,
      });
      this.$router.replace({ name: "superCategories" });
    }
  }

  validateHelper() {
    const isValidated = this.getLoginHelper && this.getLoginHelper.validated;
    if (!isValidated) {
      this.LOGIN_HELPER(null);
      this.$router.replace({ name: "login" });
    }
  }

  @Watch("country", { deep: true })
  setDefaultCity() {
    if (this.getAvailableCities && this.getAvailableCities[0]) {
      this.city = this.getAvailableCities[0];
    }
  }

  get getAvailableCities() {
    let response = this.getCities;
    if (this.country && this.country.country_code) {
      response = response.filter((city) => {
        if (
          city &&
          city.country_code &&
          city.country_code == this.country.country_code &&
          city.is_open
        ) {
          return city;
        }
      });
    }
    return response;
  }

  _routeLogin() {
    if (this.getPathTemporal) {
      this.$router.push(this.getPathTemporal);
      this.PATH_TEMPORAL(null);
    } else {
      this.$router.replace({ name: "superCategories" });
    }
  }

  _validate() {
    this.wrong = [];
    if (this.form) {
      const name = this.form.first_name;
      const lastName = this.form.last_name;
      const email = this.form.email;
      const password = this.form.password;
      if (!name || !name.length) {
        this.wrong.push("name");
      }
      if (!lastName || !lastName.length) {
        this.wrong.push("lastName");
      }
      if (!email || !email.length) {
        this.wrong.push("email");
      }
      if (!password || !password.length || password.length < 6) {
        this.wrong.push("password");
      }
    }
  }

  async _send() {
    this.isLoading = true;
    try {
      const form = this.form;
      if (form.password === "") delete form.password;
      if (form.email === "") delete form.email;
      this._validate();
      if (this.wrong.length === 0) {
        let commerce_id = 3;
        if (this.city && this.city.id) {
          commerce_id = this.city.id;
        }
        const data = {
          ...form,
          ...{
            country_id: this.country.id,
            cellphone: this.$route.params.cellPhone,
            commerce_id: commerce_id,
          },
        };
        await this.action_createUser(data);
        let formLogin = {
          email: this.form.email,
          password: this.form.password,
          commerce_id: commerce_id,
        };
        await this.action_postLogin(formLogin);
        await this.action_getCountry(this.country.id);
        await this.action_getCity(this.city.id);
        await this.sendSegmentInfo();
        this.LOGIN_HELPER(null);
        this._routeLogin();
      }
    } catch (error) {
      this.showLoginButton = true;
      let message = error;
      if (error && error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
      }
      this.$swal({
        title: "Error creando nuevo usuario",
        text: message,
      });
      this.isLoading = false;
    }
  }

  get getSubmitButtonLabel() {
    if (this.isLoading) {
      return "Creando usuario...";
    }
    return "Registrarme";
  }

  async sendSegmentInfo() {
    try {
      await this.action_getUser();
      if (
        this.getUser &&
        this.getUser.id &&
        this.getUser.cellphone &&
        this.getUser.email &&
        this.getUser.created_at &&
        this.getUser.university &&
        this.getUser.university.id
      ) {
        const segmentInfo = {
          id: this.getUser.id,
          user_id: this.getUser.id,
          cellphone: this.getUser.cellphone,
          email: this.getUser.email,
          phone: this.getUser.cellphone,
          created_at: this.getUser.created_at,
          country_id: this.getUser.university.id,
        };
        segment_track("account_created", segmentInfo);
      }
    } catch (error) {
      // Do Nothing!
    }
  }

  _login() {
    this.$router.push({ name: "login" });
    this.showLoginButton = false;
  }

  _onClose() {
    localStorage.removeItem("_tc");
    // remove the axios default heade
    delete configService.defaults.headers.common["Authorization"];
    this.$router.push({ name: "login" });
  }

  _country() {
    this.IS_SELECT_COUNTRY(false);
  }
}
